export class UpdateEntityApiKey {
    constructor(
        public readonly id: number,
        public readonly entityId: number | undefined,
        public readonly name: string,
        public readonly scopes: string[],
        public readonly isActive?: boolean,
    ) {}
}
